<script>
    import Product from '../../Services/Product.js';

    export default {
        props: {
            variant: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                service: Product
            }
        },
        mounted() {
            if (this.variant) {
                this.service.setVariant(this.variant);
            }
        },
        render() {
            return this.$scopedSlots.default(
                this.service.variant
            );
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Product/CurrentVariant.vue